<p-button
  icon="pi pi-trash"
  severity="danger"
  [text]="true"
  [attr.data-testid]="testId()"
  (onClick)="onClick($event)"
/>
